import { useState } from 'react';

const COUNTRY_KEY = 'selectedCountry';
const DEFAULT_COUNTRY = 'IT';
const SUPPORTED_COUNTRIES = ['IT', 'ES'];

export const useCountry = () => {
  const [country, setCountryState] = useState(
    () => localStorage.getItem(COUNTRY_KEY) || DEFAULT_COUNTRY
  );

  const setCountry = (code) => {
    localStorage.setItem(COUNTRY_KEY, code);
    setCountryState(code);
  };

  return { country, setCountry, SUPPORTED_COUNTRIES };
};

export { SUPPORTED_COUNTRIES, DEFAULT_COUNTRY, COUNTRY_KEY };
